import React, { useState } from 'react';
import { settleDaily } from '@/api/Admin/commission';
import { Calendar, CheckCircle2 } from 'lucide-react';
import dayjs, { Dayjs } from 'dayjs';

const SettleDaily: React.FC = () => {
    const [startDate, setStartDate] = useState<Dayjs | null>(dayjs());
    const [endDate, setEndDate] = useState<Dayjs | null>(dayjs());
    const [loading, setLoading] = useState(false);

    const handleSettle = async () => {
        if (!startDate) {
            alert('Vui lòng chọn ngày để tất toán');
            return;
        }

        setLoading(true);
        try {
            const startDateStr = startDate.format('YYYY-MM-DD');
            const endDateStr = endDate ? endDate.format('YYYY-MM-DD') : startDateStr;
            await settleDaily(startDateStr, endDateStr);
            alert('Tất toán thành công!');
        } catch (error) {
            console.error('Settle error:', error);
            alert('Có lỗi xảy ra khi tất toán.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-6 max-w-2xl mx-auto">
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md border border-gray-200 dark:border-gray-700">
                <div className="p-6 space-y-6">
                    <div className="flex items-center gap-3 border-b pb-4 border-gray-100 dark:border-gray-700">
                        <div className="p-2 bg-blue-50 dark:bg-blue-900/30 rounded-lg">
                            <Calendar className="w-6 h-6 text-blue-600 dark:text-blue-400" />
                        </div>
                        <div>
                            <h2 className="text-xl font-bold text-gray-900 dark:text-white m-0">Tất toán hàng ngày</h2>
                            <p className="text-gray-500 dark:text-gray-400 text-sm mt-1">Thực hiện tất toán lợi nhuận và hoa hồng cho ngày được chọn</p>
                        </div>
                    </div>

                    <div className="bg-gray-50 dark:bg-gray-900/50 p-6 rounded-lg border border-gray-100 dark:border-gray-700 italic text-gray-600 dark:text-gray-300 text-sm">
                        * Hệ thống sẽ tính toán và phân phối lợi nhuận dựa trên dữ liệu giao dịch của ngày này.
                        Hàng ngày mặc định sẽ là ngày hiện tại. Đảm bảo tất cả dữ liệu doanh thu đã được nhập chính xác trước khi thực hiện.
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                        <div>
                            <label className="block mb-2 font-medium text-gray-900 dark:text-gray-100">Chọn ngày tất toán:</label>
                            <input
                                type="date"
                                value={startDate ? startDate.format('YYYY-MM-DD') : ''}
                                onChange={(e) => setStartDate(e.target.value ? dayjs(e.target.value) : null)}
                                className="w-full h-12 px-4 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:outline-none transition-all"
                            />
                        </div>
                        <div>
                            <label className="block mb-2 font-medium text-gray-900 dark:text-gray-100">Chọn ngày kết thúc tất toán:</label>
                            <input
                                type="date"
                                value={endDate ? endDate.format('YYYY-MM-DD') : ''}
                                onChange={(e) => setEndDate(e.target.value ? dayjs(e.target.value) : null)}
                                className="w-full h-12 px-4 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:outline-none transition-all"
                            />
                        </div>

                    </div>

                    <button
                        onClick={handleSettle}
                        disabled={loading}
                        className="w-full h-12 flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white font-semibold rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-lg"
                    >
                        {loading ? (
                            <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                        ) : (
                            <CheckCircle2 className="w-5 h-5" />
                        )}
                        Thực hiện tất toán
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SettleDaily;
